var _style, _path, _path2, _path3, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg09Csharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9A4993;}\n\t.st1{fill:#6A1577;}\n\t.st2{fill:#813084;}\n\t.st3{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    className: "st0",
    d: "M412.4,174.8c0-6.1-1.3-11.6-4-16.2c-2.6-4.6-6.5-8.4-11.7-11.4c-43.2-24.9-86.5-49.8-129.7-74.7 c-11.7-6.7-22.9-6.5-34.5,0.3c-17.2,10.1-103.4,59.5-129,74.4c-10.6,6.1-15.7,15.5-15.7,27.7c0,50.1,0,100.3,0,150.4 c0,6,1.3,11.3,3.8,15.9c2.6,4.7,6.6,8.7,11.9,11.8c25.7,14.9,111.8,64.2,129,74.4c11.6,6.8,22.9,7.1,34.5,0.3 c43.2-25,86.5-49.8,129.7-74.7c5.4-3.1,9.3-7,11.9-11.8c2.5-4.6,3.8-9.9,3.8-15.9C412.4,325.2,412.4,224.9,412.4,174.8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M250.5,249.5L91.4,341.1c2.6,4.7,6.6,8.7,11.9,11.8c25.7,14.9,111.8,64.2,129,74.4 c11.6,6.8,22.9,7.1,34.5,0.3c43.2-25,86.5-49.8,129.7-74.7c5.4-3.1,9.3-7,11.9-11.8L250.5,249.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    className: "st1",
    d: "M203.4,276.6c9.3,16.2,26.7,27.1,46.6,27.1c20.1,0,37.6-11,46.8-27.4l-46.3-26.8L203.4,276.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "M412.4,174.8c0-6.1-1.3-11.6-4-16.2l-157.9,90.9l158.1,91.6c2.5-4.6,3.8-9.9,3.8-15.9 C412.4,325.2,412.4,224.9,412.4,174.8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st3",
    d: "M296.8,276.3c-9.2,16.3-26.7,27.4-46.8,27.4c-20,0-37.4-10.9-46.6-27.1 c-4.5-7.9-7.1-16.9-7.1-26.6c0-29.7,24-53.7,53.7-53.7c19.8,0,37.1,10.8,46.4,26.8l46.9-27c-18.7-32.2-53.5-53.9-93.4-53.9 c-59.6,0-107.8,48.3-107.8,107.8c0,19.5,5.2,37.9,14.3,53.7C175,336,210,357.8,250,357.8c40.1,0,75.1-21.9,93.7-54.4L296.8,276.3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_32_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2_",
    x: 345.4,
    y: 224.5,
    className: "st3",
    width: 10.7,
    height: 51.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: 369.1,
    y: 224.5,
    className: "st3",
    width: 10.7,
    height: 51.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_31_",
    x: 336.8,
    y: 233.2,
    className: "st3",
    width: 51.7,
    height: 10.7
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_23_",
    x: 336.8,
    y: 256.8,
    className: "st3",
    width: 51.7,
    height: 10.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg09Csharp);
export default __webpack_public_path__ + "static/media/09_csharp.116c3a3f99c167c3ee3c5881d3b81a7d.svg";
export { ForwardRef as ReactComponent };